import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-slate-600/30 bg-blue-950 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-41" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-42" data-mp="xt92bh6j0u1m">
        <h2 id="closing-title" className="text-balance text-center text-3xl font-extrabold uppercase leading-tight tracking-tight text-stone-50 sm:text-4xl" data-id="element-43" data-mp="xsfqi1spnecm">
          Stop Guessing. <span className="text-yellow-400" data-id="element-44" data-mp="17qvlifuuz7re">Start Understanding Diesel Engines &amp; Generators.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-45" data-mp="1litm22ai7vby">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border-l-4 border-yellow-400 bg-slate-950 px-4 py-3 text-sm font-semibold text-stone-50" data-id="element-46" data-mp="1hi9paztuetqc" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-yellow-400" aria-hidden="true" data-id="element-47" data-mp="2carz8ufz0ecm" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}